import { render, staticRenderFns } from "./PackageView.vue?vue&type=template&id=5a5db785&scoped=true"
import script from "./PackageView.vue?vue&type=script&lang=js"
export * from "./PackageView.vue?vue&type=script&lang=js"
import style0 from "./PackageView.vue?vue&type=style&index=0&id=5a5db785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5db785",
  null
  
)

export default component.exports